// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `pre code.hljs {
  display: block;
  overflow-x: auto;
  padding: 1em;
}
code.hljs {
  padding: 3px 5px;
}
/*
 * Visual Studio 2015 dark style
 * Author: Nicolas LLOBERA <nllobera@gmail.com>
 */
.hljs {
  background: #1E1E1E;
  color: #DCDCDC;
}
.hljs-keyword,
.hljs-literal,
.hljs-symbol,
.hljs-name {
  color: #569CD6;
}
.hljs-link {
  color: #569CD6;
  text-decoration: underline;
}
.hljs-built_in,
.hljs-type {
  color: #4EC9B0;
}
.hljs-number,
.hljs-class {
  color: #B8D7A3;
}
.hljs-string,
.hljs-meta .hljs-string {
  color: #D69D85;
}
.hljs-regexp,
.hljs-template-tag {
  color: #9A5334;
}
.hljs-subst,
.hljs-function,
.hljs-title,
.hljs-params,
.hljs-formula {
  color: #DCDCDC;
}
.hljs-comment,
.hljs-quote {
  color: #57A64A;
  font-style: italic;
}
.hljs-doctag {
  color: #608B4E;
}
.hljs-meta,
.hljs-meta .hljs-keyword,
.hljs-tag {
  color: #9B9B9B;
}
.hljs-variable,
.hljs-template-variable {
  color: #BD63C5;
}
.hljs-attr,
.hljs-attribute {
  color: #9CDCFE;
}
.hljs-section {
  color: gold;
}
.hljs-emphasis {
  font-style: italic;
}
.hljs-strong {
  font-weight: bold;
}
/*.hljs-code {
  font-family:'Monospace';
}*/
.hljs-bullet,
.hljs-selector-tag,
.hljs-selector-id,
.hljs-selector-class,
.hljs-selector-attr,
.hljs-selector-pseudo {
  color: #D7BA7D;
}
.hljs-addition {
  background-color: #144212;
  display: inline-block;
  width: 100%;
}
.hljs-deletion {
  background-color: #600;
  display: inline-block;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./node_modules/highlight.js/styles/vs2015.css"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,gBAAA;EACA,YAAA;AACF;AACA;EACE,gBAAA;AACF;AACA;;;EAGE;AACF;EACE,mBAAA;EACA,cAAA;AACF;AACA;;;;EAIE,cAAA;AACF;AACA;EACE,cAAA;EACA,0BAAA;AACF;AACA;;EAEE,cAAA;AACF;AACA;;EAEE,cAAA;AACF;AACA;;EAEE,cAAA;AACF;AACA;;EAEE,cAAA;AACF;AACA;;;;;EAKE,cAAA;AACF;AACA;;EAEE,cAAA;EACA,kBAAA;AACF;AACA;EACE,cAAA;AACF;AACA;;;EAGE,cAAA;AACF;AACA;;EAEE,cAAA;AACF;AACA;;EAEE,cAAA;AACF;AACA;EACE,WAAA;AACF;AACA;EACE,kBAAA;AACF;AACA;EACE,iBAAA;AACF;AACA;;EAEE;AACF;;;;;;EAME,cAAA;AACF;AACA;EACE,yBAAA;EACA,qBAAA;EACA,WAAA;AACF;AACA;EACE,sBAAA;EACA,qBAAA;EACA,WAAA;AACF","sourcesContent":["pre code.hljs {\n  display: block;\n  overflow-x: auto;\n  padding: 1em\n}\ncode.hljs {\n  padding: 3px 5px\n}\n/*\n * Visual Studio 2015 dark style\n * Author: Nicolas LLOBERA <nllobera@gmail.com>\n */\n.hljs {\n  background: #1E1E1E;\n  color: #DCDCDC\n}\n.hljs-keyword,\n.hljs-literal,\n.hljs-symbol,\n.hljs-name {\n  color: #569CD6\n}\n.hljs-link {\n  color: #569CD6;\n  text-decoration: underline\n}\n.hljs-built_in,\n.hljs-type {\n  color: #4EC9B0\n}\n.hljs-number,\n.hljs-class {\n  color: #B8D7A3\n}\n.hljs-string,\n.hljs-meta .hljs-string {\n  color: #D69D85\n}\n.hljs-regexp,\n.hljs-template-tag {\n  color: #9A5334\n}\n.hljs-subst,\n.hljs-function,\n.hljs-title,\n.hljs-params,\n.hljs-formula {\n  color: #DCDCDC\n}\n.hljs-comment,\n.hljs-quote {\n  color: #57A64A;\n  font-style: italic\n}\n.hljs-doctag {\n  color: #608B4E\n}\n.hljs-meta,\n.hljs-meta .hljs-keyword,\n.hljs-tag {\n  color: #9B9B9B\n}\n.hljs-variable,\n.hljs-template-variable {\n  color: #BD63C5\n}\n.hljs-attr,\n.hljs-attribute {\n  color: #9CDCFE\n}\n.hljs-section {\n  color: gold\n}\n.hljs-emphasis {\n  font-style: italic\n}\n.hljs-strong {\n  font-weight: bold\n}\n/*.hljs-code {\n  font-family:'Monospace';\n}*/\n.hljs-bullet,\n.hljs-selector-tag,\n.hljs-selector-id,\n.hljs-selector-class,\n.hljs-selector-attr,\n.hljs-selector-pseudo {\n  color: #D7BA7D\n}\n.hljs-addition {\n  background-color: #144212;\n  display: inline-block;\n  width: 100%\n}\n.hljs-deletion {\n  background-color: #600;\n  display: inline-block;\n  width: 100%\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
